import { ActivityAction, ActivityState } from 'store/data/activity';
import { domainUtility } from 'utility';

const initialState: ActivityState = { allIds: [], byId: {} };

const activityReducer = (
  state: ActivityState = initialState,
  action: ActivityAction,
): ActivityState => {
  switch (action.type) {
    case 'data/activity/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/activity/SET':
      return domainUtility.set(state, action.payload);
    case 'data/activity/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/activity/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/activity/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default activityReducer;
